<div class="pos-r padding-24" *ngIf="dataLoading">
  <app-loader></app-loader>
</div>

<div class="mt-24" *ngIf="!dataLoading">
  <div class="bg-gray-pale mb-24 pt-16 pb-16 pl-24 pr-24 br-r" *ngIf="brigadeUnassigned.data.usersList && brigadeUnassigned.data.usersList.length">
    <div class="tt-uppercase color-gray-dark">Не прикреплены к бригаде ({{ brigadeUnassigned.data.usersList.length }})</div>
    <div class="grid grid--gap-24">
      <div class="grid__box grid__box--size-2 mt-16" *ngFor="let user of brigadeUnassigned.data.usersList; let index = index">
        <div class="grid grid--gap-4 grid--va-top">
          <div class="grid__box grid__box--size-min pt-2">
            <app-icon [color]="'pink'" [size]="'14'" [glyph]="'warning-round'"></app-icon>
          </div>
          <div class="grid__box" style="width: 1px">
            <div class="user__container">
              <div class="user__name">
                <div class="text-ellipsis">
                  {{ user.employee.full_name }}
                </div>
              </div>
              <app-user-popover [user]="user"></app-user-popover>
            </div>
          </div>
          <div class="grid__box grid__box--size-min pt-2">
            <app-user-actions-popover [index]="index + 1" [user]="user" [sector]="filter.plotSelected" (onUpdateWidget)="onUpdateWidget($event)"></app-user-actions-popover>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="pos-r">
    <app-loader *ngIf="brigadeTable.brigadesLoading"></app-loader>
    <div class="filter">
      <div class="grid grid--va-bottom">
        <div class="grid__box grid__box--size-2">
          <app-field>
            <label>Бригада</label>
            <app-combobox
              [items]="brigadeFilter.data.brigadesList"
              (callback)="onChangeSelectedBrigade($event)"
              [textKey]="'brigade_name'"
              [defaultText]="'Искать по бригадам'"
              [initBy]="brigadeFilter.brigadeSelected"
              [name]="'brigadeName'"
            ></app-combobox>
          </app-field>
        </div>
        <div class="grid__box grid__box--size-2">
          <app-field>
            <label>ФИО</label>
            <input class="input-text" type="text" [(ngModel)]="brigadeFilter.brigadeUserName" id="fullNameBrigadeUser" placeholder="Искать по сотрудникам" />
          </app-field>
        </div>
        <div class="grid__box grid__box--size-min">
          <div class="grid grid--va-middle">
            <div class="grid__box grid__box--size-min">
              <button
                class="button"
                type="button"
                (click)="onApplyFilter()"
                id="appApplyBrigadeFilter"
                [disabled]="!brigadeFilter.brigadeSelected && brigadeFilter.brigadeUserName.length === 0"
              >
                Применить
              </button>
            </div>
            <div class="grid__box grid__box--size-min">
              <button class="ctrl link link--dotted-blue-dark" (click)="onResetFilter()" id="appResetBrigadeFilter">Сбросить</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mt-24">
      <app-brigades-actions-block
        [brigadeOperations]="brigadeOperations"
        (onOpenDisbandmentConfirmDialog)="onOpenDisbandmentConfirmDialog()"
        (onOpenMergeDialog)="onOpenMergeDialog()"
        (onUpdateWidget)="onUpdateWidget($event)"
      ></app-brigades-actions-block>
    </div>
    <div class="mt-32">
      <table class="tbl tbl--full tbl--hovered">
        <colgroup>
          <col width="1%" />
          <col width="5%" />
          <col width="15%" />
          <col width="15%" />
          <col width="59%" />
          <col width="5%" />
        </colgroup>
        <thead>
          <tr>
            <th>
              <app-role-access [action]="'disable'" [permission]="'brigade.edit'" [placement]="'bottom-left'">
                <app-checkbox>
                  <input
                    data-role-element
                    type="checkbox"
                    [checked]="brigadeTable.isAllBrigadesChecked"
                    (change)="onChangeAllBrigadesState($event.target.checked, null)"
                    id="appChangeStateAllBrigades"
                  />
                </app-checkbox>
              </app-role-access>
            </th>
            <th>ID</th>
            <th>Название</th>
            <th>Бригадиры</th>
            <th>Состав</th>
            <th>Количество сотрудников</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let brigade of brigadeTable.data.brigadesList">
            <td>
              <app-role-access [action]="'disable'" [permission]="'brigade.edit'" [placement]="'bottom-left'">
                <app-checkbox>
                  <input
                    data-role-element
                    type="checkbox"
                    [checked]="brigade.is_checked"
                    (change)="onChangeBrigadeState($event.target.checked, brigade)"
                    id="{{ 'appChangeStateBrigade' + brigade.id }}"
                  />
                </app-checkbox>
              </app-role-access>
            </td>
            <td>{{ brigade.id }}</td>
            <td>
              <div class="grid grid--gap-4 grid--va-top">
                <div class="grid__box" style="width: 1px">
                  <div class="user__container">
                    <div class="user__name">
                      <div class="text-ellipsis">
                        {{ brigade.brigade_name }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="grid__box grid__box--size-min pt-2">
                  <app-brigade-actions-popover [brigade]="brigade"></app-brigade-actions-popover>
                </div>
              </div>
            </td>
            <td>
              <div class="grid grid--gap-4 grid--va-top">
                <div class="grid__box" style="width: 1px">
                  <div class="user__container">
                    <div class="user__name">
                      <div class="text-ellipsis">
                        {{ brigade.brigade_head.employee.full_name }}
                      </div>
                    </div>
                    <app-user-popover [user]="brigade && brigade.brigade_head"></app-user-popover>
                  </div>
                </div>
                <div class="grid__box grid__box--size-min pt-2">
                  <app-user-actions-popover
                    [user]="brigade && brigade.brigade_head"
                    [brigade]="brigade"
                    [sector]="filter.plotSelected"
                    (onUpdateWidget)="onUpdateWidget($event)"
                  ></app-user-actions-popover>
                </div>
              </div>
            </td>
            <td>
              <div class="grid grid--gap-24">
                <div class="grid__box grid__box--size-3 mb-16" *ngFor="let user of brigade.brigade_workers">
                  <div class="grid grid--gap-4 grid--va-top">
                    <div class="grid__box" style="width: 1px">
                      <div class="user__container">
                        <div class="user__name">
                          <div class="text-ellipsis">
                            {{ user && user.employee && user.employee.full_name }}
                          </div>
                        </div>
                        <app-user-popover [user]="user" [brigade]="brigade"></app-user-popover>
                      </div>
                    </div>
                    <div class="grid__box grid__box--size-min pt-2">
                      <app-user-actions-popover
                        [user]="user"
                        [sector]="filter.plotSelected"
                        [brigade]="brigade"
                        (onUpdateWidget)="onUpdateWidget($event)"
                      ></app-user-actions-popover>
                    </div>
                  </div>
                </div>
              </div>
            </td>
            <td>{{ brigade.brigade_count_workers + 1 }}</td>
          </tr>
          <tr *ngIf="brigadeTable.data.brigadesList && !brigadeTable.data.brigadesList.length" class="tr--reset-highlight">
            <td colspan="6">
              <div class="ta-center color-gray-dark pt-32 mt-8">Пока нет ни одной бригады.</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="mb-24">
      <app-pagination (onLoadPartial)="onLoadPartial($event)"></app-pagination>
    </div>
    <div class="mt-24">
      <app-brigades-actions-block
        [brigadeOperations]="brigadeOperations"
        (onOpenDisbandmentConfirmDialog)="onOpenDisbandmentConfirmDialog()"
        (onOpenMergeDialog)="onOpenMergeDialog()"
        (onUpdateWidget)="onUpdateWidget($event)"
      ></app-brigades-actions-block>
    </div>
  </div>
</div>
